import {SupportedLocales} from '#types/locale.js';

export const profileLang = {
  [SupportedLocales.EN]: {
    yourTitle: 'Your Profile',
    yourCaption: 'View your account information.',
    otherTitle: (name: string) => `${name}'s Profile`,
    otherCaption: (name: string) => `View ${name}'s account information.`,
    joined: 'Joined',
    email: 'Email',
    teams: 'Teams',
    organization: 'Organization',
    emptyValue: '—',
    loadError: 'Could not load this profile.',
  },
  [SupportedLocales.ES]: {
    yourTitle: 'Tu perfil',
    yourCaption: 'Consulta la información de tu cuenta.',
    otherTitle: (name: string) => `Perfil de ${name}`,
    otherCaption: (name: string) =>
      `Consulta la información de la cuenta de ${name}.`,
    joined: 'Se unió',
    email: 'Correo electrónico',
    teams: 'Equipos',
    organization: 'Organización',
    emptyValue: '—',
    loadError: 'No se pudo cargar este perfil.',
  },
};
